/* eslint-disable camelcase */
import request from '@/utils/request'

export function fetchDataCombo (p_data, headers) {
  return request({
    headers,
    url: '/form/data/list',
    method: 'get',
    params: p_data
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js